import $ from 'jquery';
import config from '../../config';
const URL_API = config.urlApi+'controlador/tipo_gasto/getTipoEgresosActive.php';

export default function getTipoEgresosActive(){
    return $.ajax({
        url: URL_API,
        type: 'GET'
    })
}